import * as actions from "../actions/types";
const contentful = require("contentful");

const client = contentful.createClient({
    // This is the space ID. A space is like a project folder in Contentful terms
    space: "gjhpubv6iem3",
    // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
    accessToken: process.env.REACT_APP_CONTENTFULLTOKEN
});

// .getEntry("gjhpubv6iem3")

const initialState = {
    error: null,
    loading: false,
    menu: client.getEntries(),
    cart: [],
    cartTotal: ""
};

// Helper functions
const cartReady = (state, payload) => {
    return {
        ...state,
        cart: payload
    };
};

const cartTotal = (state, payload) => {
    return {
        ...state,
        cartTotal: payload
    };
};

const cartOrderStart = state => {
    return {
        ...state,
        loading: true
    };
};

const cartOrderEnd = state => {
    return {
        ...state,
        loading: false
    };
};

const cartOrderSuccess = state => {
    return {
        ...state,
        loading: false,
        error: false
    };
};

const cartOrderFail = (state, payload) => {
    return {
        ...state,
        error: payload
    };
};

// Clean up func to clean state
const cleanUp = state => {
    return {
        ...state,
        error: null,
        loading: false
    };
};

// As second param is actions so i did destruction
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case actions.CLEAN_UP:
            return cleanUp(state);

        case actions.CART_READY:
            return cartReady(state, payload);

        case actions.TOTAL_READY:
            return cartTotal(state, payload);

        case actions.CART_ORDER_START:
            return cartOrderStart(state);

        case actions.CART_ORDER_END:
            return cartOrderEnd(state);

        case actions.CART_ORDER_SUCCESS:
            return cartOrderSuccess(state);

        case actions.CART_ORDER_FAIL:
            return cartOrderFail(payload);

        default:
            return state;
    }
};
